import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e56b741"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container p-5" }
const _hoisted_2 = { class: "text-center mb-3 mb-lg-5" }
const _hoisted_3 = { class: "fs-6 mb-3 mb-lg-5 lh-lg" }
const _hoisted_4 = { class: "fs-6 mb-3 lh-lg" }
const _hoisted_5 = { class: "fs-6 mb-3 mb-lg-5 lh-lg" }
const _hoisted_6 = { class: "fw-bold fs-6" }
const _hoisted_7 = { class: "d-flex justify-content-center my-3 my-lg-5" }

import { computed, watchEffect } from 'vue'
import { useStore } from 'vuex'
import { translate } from '@/languages/i18n'
import { AUTH_STORE } from '@/store/constants'
import Button from '@/components/button/index.vue'
import { useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()

const store = useStore()
const checkConfirm = localStorage.getItem('checkConfirm')
watchEffect(() => {
  if (!checkConfirm) router.push('/community/users/forgot_email')
  window.addEventListener('unload', function () {
    localStorage.removeItem('checkConfirm')
  })
})
const forgotEmailData = computed(() => store.getters[AUTH_STORE.GETTERS.FORGOT_EMAIL_DATA])
const sendConfirmation = () => {
  router.push('/community/users/forgot_email_finished')
  store.dispatch(AUTH_STORE.ACTIONS.SET_FORGOT_EMAIL_DATA, {
    emailCurrent: '',
    email: '',
    secretWord: '',
  })
  localStorage.setItem('checkSubmit', true)
  localStorage.removeItem('checkConfirm')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(translate)(`SE45resetEmail`)), 1),
    _createElementVNode("h2", _hoisted_3, _toDisplayString(_unref(translate)('SE45description1')), 1),
    _createElementVNode("h2", _hoisted_4, _toDisplayString(_unref(translate)('SE45description2')), 1),
    _createElementVNode("h2", _hoisted_5, _toDisplayString(_unref(translate)('SE45description3')), 1),
    _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(translate)('SE45emailToReset')), 1),
    _createElementVNode("p", null, _toDisplayString(_unref(forgotEmailData).email), 1),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(Button, {
        title: _unref(translate)('CA60sendConfirm'),
        type: 'secondary',
        onClick: sendConfirmation
      }, null, 8, ["title"])
    ])
  ]))
}
}

})